import { addNotification as notify } from "reapop";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";

import * as NotificationsActionCreators from "../common/notification";
import { Messages } from "../configuration";

export function FireErrorActions(error) {
    var errorCode = error.responseStatus ? error.responseStatus.errorCode : error;
    var errorType = error.responseStatus && error.responseStatus.message ? error.responseStatus.message : '';
    //var errorAction;
    var errorMessage = ""; 
    
    if(Messages.Errors[errorType]){
        errorMessage = Messages.Errors[errorType];
    }
    else if(Messages.Errors[errorCode]){
        errorMessage = Messages.Errors[errorCode];
    }
    else if(error.responseStatus && error.responseStatus.message) {
        errorMessage = error.responseStatus.message;
    } else {
        errorMessage = errorCode ? errorCode.message ? errorCode.message : errorCode : Messages.SessionTimeout;
    }

    if (errorCode === Messages.HttpCode.Unauthorized) {
        errorMessage = Messages.HttpCodeMessage.Code401;
    }

    return concat$(
        Observable.of(
            notify(
                NotificationsActionCreators.notifyDanger(
                    undefined,
                    errorMessage
                )
            )
        )
    );
}